import React, { useState, forwardRef, useEffect } from "react";
// We neeed to use this deprecated module for now until expo fixes release channels
import { StyleSheet, Keyboard, Pressable, View } from "react-native";
import { useTheme, Modal, Portal, ActivityIndicator } from "react-native-paper";
import { ScrollView } from "react-native-gesture-handler";
import { ThemeType } from "../../theme/theme";
import { Button, Spacer, Text } from "../../components";
import { Stack } from "../layout/stack";
import { translate } from "../../i18n";
import { setBannerMessagesSeen } from "../../redux/actions/actionCreators";
import { useDispatch } from "react-redux";

export interface IBannerMessageModalProps extends Record<string, any> {
}

export const BannerMessageModal = forwardRef((props: IBannerMessageModalProps, ref: any) => {
  const dispatch = useDispatch();
  const { bannerMessages } = props;
  const theme = useTheme() as ThemeType;
  const [isModalVisible, setModalVisible] = useState(false);
  const styles = getStyles(theme);

  useEffect(() => {
    if (bannerMessages && bannerMessages.length) {
      setModalVisible(true);
    }
    return () => { }
  }, [bannerMessages]);

  const onCloseHandler = (item: any) => {
    const ids = bannerMessages.map(({ id }: Record<string, any>) => id);
    dispatch(setBannerMessagesSeen(ids));
    setModalVisible(false);
  };

  return (
    <Portal>
      <Modal
        visible={isModalVisible}
        dismissable={false}
        contentContainerStyle={styles.modalContainer}>
        <ScrollView>
          <Stack space="small" horizontalSpace="tiny">
            <Stack space="largerPlus" style={styles.modalContent}>
              {bannerMessages.map(({ prop_name: propName, company_name: companyName, body }: Record<string, any>) => (
                <Stack space="small">
                  <Stack space="tiny">
                    {companyName && <Text style={styles.modalCompany}>{companyName}</Text>}
                    <Text style={styles.modalProperty}>{propName}</Text>
                  </Stack>
                  <Text style={styles.modalBody}>{body}</Text>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </ScrollView>
        <Spacer size="massive" />
        <Button
          onPress={onCloseHandler}
          mode="contained"
          style={styles.modalButton}>
          {translate("homeStack.ok")}
        </Button>
      </Modal>
    </Portal>
  );
});

const getStyles = (theme: ThemeType) => {
  const { colors, spacing, fontSize } = theme;
  return StyleSheet.create({
    modalContainer: {
      display: "flex",
      padding: spacing.medium,
      paddingHorizontal: spacing.small,
      paddingBottom: spacing.smaller,
      marginHorizontal: spacing.medium,
      backgroundColor: colors.background,
      borderRadius: 10,
      flexDirection: "column",
      maxHeight: '95%',
    },
    modalContent: {
      padding: spacing.smaller,
      minHeight: 180,
    },
    modalCompany: {
      fontSize: fontSize.large,
    },
    modalProperty: {
      fontWeight: "bold",
      fontSize: fontSize.larger,
    },
    modalBody: {
      fontSize: fontSize.large,
    },
    modalButton: {
      width: "30%",
      marginTop: spacing.large,
      alignSelf: "flex-end",
      position: "absolute",
      bottom: spacing.smaller,
      right: spacing.medium,
    },
  });
};
